import React from 'react'
import { Container, LimitContainer } from './styles'
import { LogoComponent } from './LogoComponent'
import { NavigationComponent } from './NavigationComponent'
import { LanguageSelectComponent } from './LanguageSelectComponent'
import { MobileMenuComponent } from './MobileMenuComponent'
import { CallToActionComponent } from './CallToActionComponent'

export function Header() {
    return (
        <Container>
            <LimitContainer
                paddingRight={['medium', 'medium', 0, 0]}
                paddingLeft={['medium', 'medium', 'xmedium', 'header']}
                paddingBottom={['xxxsmall', 'xxxsmall', 'xxsmall', 'xxxsmall']}
                paddingTop={['xxxsmall', 'xxxsmall', 'xxsmall', 'xxxsmall']}
            >
                <LogoComponent />
                <NavigationComponent />
                <LanguageSelectComponent />
                <CallToActionComponent />
                <MobileMenuComponent />
            </LimitContainer>
        </Container>
    )
}
